import APIService from "./APIService";

const UserDetailsAPI = {
  // Get user details for the authenticated user, or for a specific user (admin)
  // If uuid is provided, passes it as a query parameter for admin access
  getUserDetails: async (uuid = null) => {
    const url = uuid
      ? `/api/v1/base/user-details?uuid=${encodeURIComponent(uuid)}`
      : `/api/v1/base/user-details`;
    return APIService.get(url);
  },

  // Create new user details
  // If data contains a uuid (admin updating another user), backend will detect it
  createUserDetails: async (data) => {
    return APIService.post(`/api/v1/base/user-details`, data);
  },

  // Update existing user details
  // If data contains a uuid (admin updating another user), backend will detect it
  updateUserDetails: async (data) => {
    return APIService.put(`/api/v1/base/user-details`, data);
  },
};

export default UserDetailsAPI;
